$(document).ready(function () {

    var products = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,

        remote: {
            url: '/ajax/search/suggestion.php?q=%QUERY',
            wildcard: '%QUERY',
            transform: function (d) {
                return d.products;
            }
        }
    });

    var categories = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,

        remote: {
            url: '/ajax/search/suggestion.php?q=%QUERY',
            wildcard: '%QUERY',
            transform: function (d) {
                return d.categories;
            }
        }
    });

    var suggestionBox = $('#search-suggestion');

    suggestionBox.typeahead(
        {
            hint: false,
            highlight: true,
            minLength: 1
        },
        {
            name: 'categories',
            source: categories,
            templates: {
                header: '<b>Kategoriler</b>'
            },
            displayKey: 'value',
            display: 'value'
        },
        {
            name: 'products',
            source: products,
            templates: {
                header: '<b>Ürünler</b>'
            },
            displayKey: 'value',
            display: 'value'
        });


    function fullTextSearch(text) {
        var q = encodeURIComponent(text);
        window.location = '/arama?q=' + q;
    }

    function fullUrlSearch(url) {
        window.location = url;
    }

    suggestionBox.bind('typeahead:select', function (event, suggestion) {
        if (suggestion.url != undefined){
            fullUrlSearch(suggestion.url);
        } else {
            fullTextSearch(suggestion.value);
        }

    });

    suggestionBox.bind('typeahead:render', function (event) {
        var dataSets = $(".tt-dataset:not(:empty)");
        $(".tt-dataset").removeClass("tt-multiple-dataset");
        if(dataSets.length > 1){
            dataSets.addClass("tt-multiple-dataset");
        }
    });

});

